import { Controller } from "@hotwired/stimulus";

// One instance per payment-method card (step4/partials/_payment_option.html.erb).
// Figma shows the initial view as a plain grid of logo+name buttons; a
// method only expands into descriptions/required fields/fee breakdown +
// its own real "Betala" submit button once clicked. Opening one card closes
// any other that's currently open (accordion-style, one choice at a time)
// via a document-level event, since each card is an independent controller
// instance on its own <form> rather than a single shared radio group.
export default class extends Controller {
  static targets = ["panel"];

  connect() {
    this.boundCloseOthers = (event) => {
      if (event.detail.controller !== this) this.setOpen(false);
    };
    document.addEventListener("payment-option:opened", this.boundCloseOthers);
  }

  disconnect() {
    document.removeEventListener("payment-option:opened", this.boundCloseOthers);
  }

  toggle() {
    const willOpen = this.panelTarget.classList.contains("hidden");
    if (willOpen) {
      document.dispatchEvent(new CustomEvent("payment-option:opened", { detail: { controller: this } }));
    }
    this.setOpen(willOpen);
  }

  setOpen(open) {
    this.panelTarget.classList.toggle("hidden", !open);
    this.element.classList.toggle("border-primary", open);
    this.element.classList.toggle("ring-1", open);
    this.element.classList.toggle("ring-primary", open);
  }
}
